import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-action',
  templateUrl: './confirm-action.component.html',
  styleUrls: ['./confirm-action.component.css']
})
export class ConfirmActionComponent implements OnInit {

  message:string;

  @Input() data;

  // @Input() set data(value){
    
  //   if(value != null){

  //     this.message = value;
  //   } 
  // }

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    
  }


  /**
   * 
   */
  onConfirm(){
    this.activeModal.close(true);
  }

}
